import React from "react";

import IndicatorDashboard from "./IndicatorDashboard";
import {
  fetchComfort,
  fetchComfortRegion,
} from "../../services/infrastructure";

export default function Comfort(props) {
  return (
    <IndicatorDashboard
      {...props}
      fetchAggregate={fetchComfort}
      fetchRegion={fetchComfortRegion}
      pairedIds={[1, 2, 3]}
      singleIds={[]}
    />
  );
}
